<template>
  <div>
    <v-layout row v-resize="onResize" column style="padding-top:56px">
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="searchResult"
        height="200"
        hide-actions
        v-model="selected"
        select-all
        item-key="guid"
        :loading="isLoading"
        :pagination.sync="pageSync"
        class="colorrows mytable"
        :hide-headers="isMobile" :class="{mobile: isMobile}"
      >
        <template v-slot:headers="props">
          <tr v-if="!isMobile">
            <th>
              <img v-if="props.all" :src="hicon2" height="32" @click.stop="toggleAll">
              <img v-if="!props.all" :src="hicon1" height="32" @click.stop="toggleAll">
            </th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable', pageSync.descending ? 'desc' : 'asc', header.value === pageSync.sortBy ? 'active' : '', 'xs-text-' + header.align]"
              @click="changeSort(header.value)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr :active="props.selected"  v-if="!isMobile">
            <td class="xs-text-center">
              <img v-if="props.selected" :src="hicon2" height="32" @click="props.selected = !props.selected">
              <img v-if="!props.selected" :src="hicon1" height="32" @click="props.selected = !props.selected">
            </td>
            <td @click="openItem(props.item)" class="text-xs-left pa-2" v-for="(head, hi) in headers" valign="top" v-bind:key="hi">
              <img v-if="head.type === 'preview'" :src="props.item.thumbScaled" height="128">
              <div v-if="head.type === 'name'">
                <span class="cTitle">{{ getCategories(props.item.categories) }}</span>
                <span v-if="getCategories(props.item.categories)">vom</span>
                <span>{{ getDate(props.item.time) }}</span><br>
                <span v-for="(category, i) in props.item.categories" v-bind:key="i"><span v-if="catObjectsByGuid[category]"
                                                                                          v-for="field in catObjectsByGuid[category].extraFields" class="pr-1"
                                                                                          v-bind:key="field.id"><span class="pr-1">{{field.name}}</span><span class="pr-1">{{getFieldValue(props.item, catObjectsByGuid[category], field)}} </span><span v-if="field.labelValue">{{field.labelValue}}</span></span></span>
                <br>
                <!--Invoice 2020-3464.pdf -->
                <span v-if="props.item.status" v-for="(guidStatus, ii) in props.item.status" v-bind:key="hi + '' + ii">
                          <span class="pr-1" v-if="catStatusByGuid[guidStatus]">Status:
                            <span  :style="getStatusStyle(catStatusByGuid[guidStatus])">
                              <span style="font-weight: bolder">
                            {{catStatusByGuid[guidStatus].title}}</span>
                            </span>
                          </span>
                        </span>
                <br>
                <span class="name">{{ props.item.name }}</span> (<span class="size pl-1">{{ toMB(props.item.size) }}</span>)
              </div>
              <div v-if="head.type === 'category'">
                {{ getCategories(props.item.categories) }}
              </div>
              <div v-if="head.type === 'extraFields'">
                <span class="pr-1">{{getFieldValue(props.item, head.category, head.field)}}</span>
                {{head.field.labelValue}}
              </div>
              <div v-if="head.type === 'date'" class="text-center">
                <span>{{ getDate(props.item.time) }}</span>
              </div>
            </td>
          </tr>
          <tr v-else>
            <td>
              <ul class="flex-content">
                <li @click="openItem(props.item)" class="text-xs-left pa-2" v-for="(head, hi) in headers" valign="top" v-bind:key="hi">
                  <img v-if="head.type === 'preview'" :src="props.item.thumbScaled" height="128">
                  <div v-if="head.type === 'name'">
                    <span class="cTitle">{{ getCategories(props.item.categories) }}</span>
                    <span v-if="getCategories(props.item.categories)">vom</span>
                    <span>{{ getDate(props.item.time) }}</span><br>
                    <span v-for="(category, i) in props.item.categories" v-bind:key="i"><span v-if="catObjectsByGuid[category]"
                                                                                              v-for="field in catObjectsByGuid[category].extraFields" class="pr-1"
                                                                                              v-bind:key="field.id"><span class="pr-1">{{field.name}}</span><span class="pr-1">{{getFieldValue(props.item, catObjectsByGuid[category], field)}} </span><span v-if="field.labelValue">{{field.labelValue}}</span></span></span>
                    <br>
                    <!--Invoice 2020-3464.pdf -->
                    <span v-if="props.item.status" v-for="(guidStatus, ii) in props.item.status" v-bind:key="hi + '' + ii">
                          <span class="pr-1" v-if="catStatusByGuid[guidStatus]">Status:
                            <span  :style="getStatusStyle(catStatusByGuid[guidStatus])">
                              <span style="font-weight: bolder">
                            {{catStatusByGuid[guidStatus].title}}</span>
                            </span>
                          </span>
                        </span>
                    <br>
                    <span class="name">{{ props.item.name }}</span> (<span class="size pl-1">{{ toMB(props.item.size) }}</span>)
                  </div>
                  <div v-if="head.type === 'category'">
                    {{ getCategories(props.item.categories) }}
                  </div>
                  <div v-if="head.type === 'extraFields'">
                    <span class="pr-1">{{getFieldValue(props.item, head.category, head.field)}}</span>
                    {{head.field.labelValue}}
                  </div>
                  <div v-if="head.type === 'date'" class="text-center">
                    <span>{{ getDate(props.item.time) }}</span>
                  </div>

                </li>
              </ul>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
    </v-layout>
   <v-layout v-resize="onResize" column style="padding-top:56px">
      <v-flex xs12>
      <v-data-table :headers="headers" :items="desserts" :search="search" :hide-headers="isMobile" :class="{mobile: isMobile}">
        <template slot="items" slot-scope="props">
          <tr v-if="!isMobile">
            <td>{{ props.item.name }}</td>
            <td class="text-xs-right">{{ props.item.calories }}</td>
            <td class="text-xs-right">{{ props.item.fat }}</td>
            <td class="text-xs-right">{{ props.item.carbs }}</td>
            <td class="text-xs-right">{{ props.item.protein }}</td>
            <td class="text-xs-right">{{ props.item.iron }}</td>
          </tr>
          <tr v-else>
            <td>
              <ul class="flex-content">
                <li class="flex-item" data-label="Name">{{ props.item.name }}</li>
                <li class="flex-item" data-label="Calories">{{ props.item.calories }}</li>
                <li class="flex-item" data-label="Fat (g)">{{ props.item.fat }}</li>
                <li class="flex-item" data-label="Carbs (g)">{{ props.item.carbs }}</li>
                <li class="flex-item" data-label="Protein (g)">{{ props.item.protein }}</li>
                <li class="flex-item" data-label="Iron (%)">{{ props.item.iron }}</li>
              </ul>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Testtabelle',
  components: {},
  data () {
    return {
      search: '',
      isMobile: false,
      desserts: [{
        value: false,
        name: 'Frozen Yogurt',
        calories: 159,
        fat: 6.0,
        carbs: 24,
        protein: 4.0,
        iron: '1%'
      }],
      headers: [
        {
          text: 'Vorschau',
          align: 'left',
          class: 'text-xs-center',
          value: 'name',
          type: 'preview',
          sortable: false
        },
        {
          text: 'Name',
          align: 'left',
          class: 'text-xs-left',
          sortable: true,
          value: 'name',
          type: 'name'
        },
        {
          text: 'Kategorien',
          class: 'text-xs-center',
          value: 'categories',
          type: 'category'},
        {
          text: 'Datum',
          value: 'time',
          class: 'text-xs-center',
          align: 'center',
          type: 'date'}
      ],
      searchResult: [
        {
          'size': 396790,
          'created': 1601640926137,
          'guid': 453975879838342,
          'guidAuthor': 'sasGuid',
          'fileHash': '0bc9260b114c3d4cbdc2d7b2fd13fd458d316bf1adeb7edc598676eba4726acf',
          'time': 1601935200000,
          'filename': '1332_Kompakt.pdf',
          'mimetype': 'application/pdf',
          'rawText': '',
          'hocrText': '',
          'thumb': '',
          'extraFields': '{\'Ausgangsrechnung_netto\':\'111\'}',
          'thumbScaled': 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAAQABAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0a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\noAKKKKAP/9k\u003d',
          'name': '1332_Kompakt.pdf',
          'status': [
            401270645548754
          ],
          'history': []
        }
      ],
      selected: [],
      isLoading: false,
      pageSync: {
        descending: true,
        page: 0,
        rowsPerPage: -1,
        sortBy: 'name',
        totalItems: -1
      },
      hicon1: './static/check_box_outline_blank.png', // head Icon
      hicon2: './static/check_box.png', // head Icon
      catObjectsByGuid: [],
      catStatusByGuid: []
    }
  },
  methods: {
    getStatusStyle: function (status) {
      var css = ''
      css += 'color:' + status.config.color + ';'
      css += 'font-weight:bold;'
      return css
    },
    getFieldValue: function (item, category, field) {
      item = Vue.prototype.$storage.checkExtraFieldStatus(item)
      let key = category.internal_id + '_' + field.key
      return item.extraFields[key]
    },
    reloadConfig: function () {
      this.scanParameter = Vue.prototype.scanApi.getScanParameter()
      this.categories = Vue.prototype.$storage.getCategories()
      this.catNames = Vue.prototype.$storage.getCategoriesNamesList()
      this.catObjectsByGuid = Vue.prototype.$storage.getCategoriesObjectGuidList()
      this.catStatusByGuid = Vue.prototype.$storage.getStatusObjectGuidList()
      this.statusList = Vue.prototype.$storage.getStatusList()
      console.log('reloadConfig', this.statusList)
    },
    toMB: function (bytes, decimals) {
      if (bytes === 0) return '0 Bytes'
      var k = 1024
      var dm = decimals <= 0 ? 0 : decimals || 2
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      var i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    getCategories: function (arrayOfGuids) {
      var items = []
      for (var i in arrayOfGuids) {
        items.push(this.catNames[arrayOfGuids[i]])
      }
      return items.join(', ')
    },
    getDate: function (str) {
      return new Date(str).toLocaleDateString('de-DE')
    },
    onGetSearchResult: function (data) {
      let showLineChart = false
      let showBarChart = true
      let lineChartType = 'daily'
      let lineChartIncrement = 1
      let minMonth = 11
      let maxMonth = 0
      this.missingLizenz = false
      if (this.dateFromObj && this.dateToObj) {
        showLineChart = true
        let cntMonths = this.monthDiff(this.dateFromObj, this.dateToObj)
        if (cntMonths <= 1) {
          lineChartIncrement = this.daysInMonth(this.dateFromObj.getMonth(), this.dateFromObj.getYear())
          lineChartType = 'daily'
        } else {
          lineChartIncrement = cntMonths
          lineChartType = 'monthly'
          if (!Vue.prototype.$sasConfig.licenseValid) {
            if (cntMonths > 3) {
              this.missingLizenz = true
            }
          }
        }
      }
      if (this.missingLizenz) {
        showLineChart = false
        showBarChart = false
      }

      this.searchResult = []
      this.sums = {}
      let sumPerDay = {}
      let sumPerMonth = {}
      let cmp = this
      this.chartData = {}
      if (data != null) {
        if (data.files != null) {
          for (let i in data.files) {
            let item = data.files[i]
            item.selected = false
            Vue.prototype.$storage.checkExtraFieldStatus(item)
            for (const [key, value] of Object.entries(item.extraFields)) {
              item[key] = value
              if (!this.sums[key]) {
                this.sums[key] = 0
              }
              let v = this.getFloatOfString(value)
              this.sums[key] += v
              let keyForSum = key.split('_')[0]
              let sumpdKey = keyForSum + '' + new Date(item.time).getDay()
              if (sumPerDay[sumpdKey]) {
                sumPerDay[sumpdKey] += v
              } else {
                sumPerDay[sumpdKey] = v
              }

              sumpdKey = keyForSum + '' + new Date(item.time).getMonth()
              minMonth = Math.min(minMonth, new Date(item.time).getMonth())
              maxMonth = Math.max(maxMonth, new Date(item.time).getMonth())
              if (sumPerMonth[sumpdKey]) {
                sumPerMonth[sumpdKey] += v
              } else {
                sumPerMonth[sumpdKey] = v
              }
            }
          }
          this.searchResult = data.files
        }
      }

      let cd = {
        labels: [],
        datasets: []
      }
      let colors = [
        '#dc2020',
        '#e06636',
        '#e09436',
        '#e2b735',
        '#e2df35',
        '#a0e235',
        '#61e232',
        '#31e05d',
        '#2fe28d',
        '#2fe2d3',
        '#2fafe2',
        '#277ae0'
      ]
      cd.labels.push('Summe')
      let cats = this.categories
      if (this.selectedCategories && this.selectedCategories.length > 0) {
        cats = this.selectedCategories
      }
      if (showBarChart) {
        for (var i in cats) {
          let cat = cats[i]
          for (var ii in cat.extraFields) {
            let field = cat.extraFields[ii]
            let key = cat.internal_id + '_' + field.key
            let dSums = cmp.sums[key]
            cd.datasets.push({
              label: cat.title + ' ' + field.name,
              backgroundColor: colors[i],
              fill: true,
              data: [dSums]
            })
          }

          this.chartData = cd
        }
      }
      //
      this.lineChartData = {
        labels: [],
        datasets: []
      }
      if (lineChartType === 'daily') {
        this.lineChartData.labels.push('Tagesverlauf')
      } else {
        this.lineChartData.labels.push('Monatsverlauf')
      }
      if (showLineChart) {
        for (let i = 0; i < lineChartIncrement; i++) {
          if (lineChartType === 'daily') {
            this.lineChartData.labels.push('' + (i + 1))
          } else if (lineChartType === 'monthly') {
            this.lineChartData.labels.push('' + this.monthNames[i + minMonth])
          }
        }

        let lineTickSum = 0
        for (var iCat in cats) {
          let cat = cats[iCat]
          let hasExtraFields = cat.extraFields && cat.extraFields.length > 0
          if (!hasExtraFields) {
            continue
          }
          let dataSet = {
            label: cat.title,
            backgroundColor: colors[iCat],
            fill: true,
            data: []
          }
          for (let i = 0; i < lineChartIncrement; i++) {
            let vsp
            if (lineChartType === 'daily') {
              let keyForSum = cat.internal_id + '' + (i + 1)
              vsp = sumPerDay[keyForSum]
            } else if (lineChartType === 'monthly') {
              let keyForSum = cat.internal_id + '' + (i + minMonth)
              vsp = sumPerMonth[keyForSum]
            }
            if (vsp !== undefined) {
              lineTickSum += vsp
            }
            dataSet.data.push(lineTickSum)
          }
          this.lineChartData.datasets.push(dataSet)
        }
      }
      this.isLoading = false
      this.computedSearch = false
      cmp.$eventHub.$emit('OnShowIdle', false)
    },
    toggleAll () {
      console.log('toggleAll', this.selected)
      if (this.selected.length) this.selected = []
      else this.selected = this.searchResult.slice()
    },
    changeSort (column) {
      if (this.pageSync.sortBy === column) {
        this.pageSync.descending = !this.pageSync.descending
      } else {
        this.pageSync.sortBy = column
        this.pageSync.descending = false
      }
    },
    onResize () {
      if (window.innerWidth < 769) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    }
  },
  mounted () {

  }
}
</script>

<style scoped>
  .mobile {
    color: #333;
  }

  @media screen and (max-width: 768px) {
    .mobile table.v-table tr {
      max-width: 100%;
      position: relative;
      display: block;
    }

    .mobile table.v-table tr:nth-child(odd) {
      border-left: 6px solid deeppink;
    }

    .mobile table.v-table tr:nth-child(even) {
      border-left: 6px solid cyan;
    }

    .mobile table.v-table tr td {
      display: flex;
      width: 100%;
      border-bottom: 1px solid #f5f5f5;
      height: auto;
      padding: 10px;
    }

    .mobile table.v-table tr td ul li:before {
      content: attr(data-label);
      padding-right: .5em;
      text-align: left;
      display: block;
      color: #999;

    }
    .v-datatable__actions__select
    {
      width: 50%;
      margin: 0px;
      justify-content: flex-start;
    }
    .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
      background: transparent;
    }

  }
  .flex-content {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .flex-item {
    padding: 5px;
    width: 50%;
    height: 40px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Testtabelle.vue